import { render, staticRenderFns } from "./addProjectAccount.vue?vue&type=template&id=23f67ac5"
import script from "./addProjectAccount.vue?vue&type=script&lang=js"
export * from "./addProjectAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports